export default __webpack_public_path__ + "deposit.9edc5548217f7a20f76a.svg";